'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import NewsletterForm from '@/app/[locale]/(default-layout)/(forms)/_components/NewsletterForm';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

type NewsletterPageClientProps = {
    domainConfiguration: DomainConfigurationDto;
};

const NewsletterPageClient: React.FC<NewsletterPageClientProps> = ({ domainConfiguration }) => {
    const t = useTranslations();

    return (
        <main className="min-h-screen">
            {/* Hero Section */}
            <section
                className="py-24 backdrop-blur-sm"
                style={{ backgroundColor: withOpacity(domainConfiguration.style.onBackgroundColor, 0.05) }}>
                <CenterLayout>
                    <div className="text-center space-y-6 max-w-4xl mx-auto">
                        <h1
                            className="text-headline-48"
                            style={{ color: domainConfiguration.style.onBackgroundColor }}>
                            {t('newsletter.hero.title')}
                        </h1>
                        <p
                            className="text-headline-20 font-semibold"
                            style={{ color: domainConfiguration.style.onBackgroundColor }}>
                            {t('newsletter.hero.subtitle')}
                        </p>
                        <p
                            className="text-body-16 max-w-3xl mx-auto"
                            style={{ color: withOpacity(domainConfiguration.style.onBackgroundColor, 0.8) }}>
                            {t('newsletter.hero.description')}
                        </p>
                    </div>
                </CenterLayout>
            </section>

            {/* Newsletter Form Section */}
            <section className="py-24">
                <CenterLayout>
                    <div className="max-w-2xl mx-auto">
                        <NewsletterForm domainConfiguration={domainConfiguration} />
                    </div>
                </CenterLayout>
            </section>
        </main>
    );
};

export default NewsletterPageClient;
